var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.rootRoute}},[_c('v-app-bar-title',[_c('img',{staticClass:"logo_L",attrs:{"src":_vm.logo}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }